import React from 'react';
import { array, func } from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import classes from './ClientsTable.module.css';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f4f4f4',
        }
    }
}))(TableRow);

const ClientsTable = ({
    clients,
    onSort,
    order,
    orderBy,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell
                        className={classes.headerCell}
                        sortDirection={sortDirection}
                        onClick={onSort('name')}
                    >
                        <Tooltip
                            title={
                                <span className={classes.tooltip}>
                                    Sort
                                </span>
                            }
                            placement="top-start"
                        >
                            <TableSortLabel
                                active={isSortedByName}
                                direction={order}
                            >
                                Name
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                    <TableCell className={classes.headerCell}>
                        Business Type
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {clients.map(client =>
                    <StyledTableRow key={client.id}>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {client.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{client.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {client.businessType?.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{client.businessType?.name}</span>
                            </Tooltip>
                        </TableCell>
                    </StyledTableRow>
                )}
            </TableBody>
        </Table>
    );
};

ClientsTable.defaultProps = {
    onSort: () => {}
};

ClientsTable.propTypes = {
    clients: array.isRequired,
    onSort:  func
};

export default ClientsTable;
